var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "#297041",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_5890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9951 5.61944C11.9849 5.55508 11.8817 4.9769 11.4628 4.55472C11.042 4.14308 10.4617 4.04126 10.3969 4.03108C10.3108 4.0169 10.2228 4.03508 10.1489 4.0809C10.1231 4.0969 9.74384 4.33435 8.99512 4.96744C9.38021 5.10344 9.87803 5.33944 10.2817 5.73435C10.6868 6.13072 10.9289 6.61835 11.0678 6.99653C11.6933 6.26562 11.9286 5.89544 11.9442 5.86999C11.9908 5.79544 12.0089 5.70635 11.9951 5.61944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34528 5.53613C7.9551 5.88813 7.50092 6.31577 6.98092 6.83213C4.77619 9.02122 4.19801 9.8965 4.17438 9.9325C4.14128 9.98341 4.12128 10.042 4.11656 10.1023L4.00056 11.5827C3.99256 11.6889 4.03074 11.7929 4.10601 11.8681C4.17438 11.9365 4.2671 11.9747 4.36347 11.9747C4.37256 11.9747 4.38201 11.9747 4.39147 11.9736L5.88274 11.8587C5.94274 11.854 6.00056 11.8347 6.0511 11.8023C6.08747 11.779 6.96856 11.2049 9.17292 9.01613C9.70456 8.48813 10.1431 8.0285 10.502 7.63541C10.4471 7.39941 10.2555 6.72595 9.77292 6.25431C9.28347 5.77541 8.57947 5.58777 8.34528 5.53613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_5890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.01f0f93ae4c9d7dbdf7bc50295374e02.svg";
export { ForwardRef as ReactComponent };